/**
 * @file       secure module
 * @version    2.0.0
 * @author     Mehran Majidi
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
//this includes the core NgIdleModule but includes 
//keepalive providers for easy wireup
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from 
        '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ShareModule } from './share/share.module';

import { SecureRoutingModule } from './secureRouting.module';
import { SecureLayoutComponent } from './core/layout/secureLayout.component';
import { SecureHeaderComponent } from './core/layout/secureHeader.component';

import { BasicAuthInterceptor } from './helper/auth.interceptor';
import { ErrorInterceptor } from './helper/error.interceptor';
import { AuthGuard } from './helper/auth.guard';
import { IdleTimeoutComponent } from './core/timeout/idleTimeout.component';
import { MatDialogModule } from '@angular/material/dialog';
//import { NotificationComponent} from './notification/notification.component';
//import { NotificationService} from './notification/notification.service';

//import { MessageComponent } from './/message/message.component';

//import {fakeBackendProvider} from './helper/fackeBackEnd';

@NgModule
({
    imports: 
    [  
        ModalModule.forRoot(),
        SecureRoutingModule,
        NgIdleKeepaliveModule.forRoot(),
        MatDialogModule,
        SecureHeaderComponent,
        SecureLayoutComponent,        
        IdleTimeoutComponent      
    ],
    exports: [],
    declarations: 
    [
//
//        NotificationComponent
    ],
    providers: 
    [
        { provide: HTTP_INTERCEPTORS, 
          useClass: BasicAuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, 
          useClass: ErrorInterceptor, multi: true },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },

        AuthGuard // ,
//        NotificationService
    ],
})
export class SecureModule {}
